import { createContext, useContext } from "react";

/**
 * Context for providing the Shadow DOM portal container to Radix UI components.
 * When the widget runs inside Shadow DOM, Radix portals need to render inside
 * the shadow tree (not document.body) to retain styling.
 *
 * Returns null when not inside a widget Shadow DOM (e.g. in the app build),
 * which tells Radix to use its default document.body behavior.
 */
const WidgetContext = createContext<HTMLElement | null>(null);

export const WidgetContextProvider = WidgetContext.Provider;
export const useWidgetContainer = () => useContext(WidgetContext);
